export default function (file) {
  return file
}
